export default "__VITE_ASSET__ce018547__"